module.exports = __webpack_public_path__ + "static/media/set_Minnows.68632446.jpg";